/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Facility service/care setting type, matching the values available in the PAL submission form.
 * @export
 */
export const FacilityServiceFilter = {
    Acute: 'ACUTE',
    Snf: 'SNF',
    Ltac: 'LTAC',
    Irf: 'IRF'
} as const;
export type FacilityServiceFilter = typeof FacilityServiceFilter[keyof typeof FacilityServiceFilter];


export function FacilityServiceFilterFromJSON(json: any): FacilityServiceFilter {
    return FacilityServiceFilterFromJSONTyped(json, false);
}

export function FacilityServiceFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityServiceFilter {
    return json as FacilityServiceFilter;
}

export function FacilityServiceFilterToJSON(value?: FacilityServiceFilter | null): any {
    return value as any;
}

